import * as z from "zod";

export const issueStoreCreditToCustomer = {
  name: "issueStoreCreditToCustomer" as const,
  input: z.object({ customerId: z.string(), amount: z.number() }),
  output: z.null(),
};
